function ppMinimumForMarket(settings, market, now = Date.now()) {
  if (!settings || settings.uninstalled) return 0;
  const limits = settings.limits || [];
  const prices = limits.filter((limit) => {
    if (!limit.active || limit.type !== 'Whole Cart' || limit.target !== 'everyone') return false;
    if (limit.start_date && Date.parse(limit.start_date) > now) return false;
    if (limit.end_date && Date.parse(limit.end_date) <= now) return false;
    const rules = limit.rules || [];
    return rules.length > 0 && rules.every((rule) => rule.rule_type === 'market' && rule.condition === 'equal_to') &&
      rules.some((rule) => rule.value === market);
  }).map((limit) => Number(limit.min_price)).filter((price) => Number.isFinite(price) && price > 0);
  return prices.length ? Math.max(...prices) : 0;
}

customElements.define('pp-buyer-guidance', class extends HTMLElement {
  connectedCallback() {
    this.renderMinimum();
    if (!document.querySelector('[data-mincart-settings]')) {
      document.addEventListener('DOMContentLoaded', () => this.renderMinimum(), { once: true });
    }
  }

  renderMinimum() {
    const source = document.querySelector('[data-mincart-settings]');
    if (!source) return;
    let settings;
    try { settings = JSON.parse(source.textContent); } catch { return; }
    const minimum = ppMinimumForMarket(settings, this.dataset.market);
    if (!minimum) return;
    const format = (amount) => new Intl.NumberFormat(this.dataset.locale, {
      style: 'currency', currency: this.dataset.baseCurrency
    }).format(amount);
    const sameCurrency = this.dataset.currency === this.dataset.baseCurrency;
    const remaining = minimum - Number(this.dataset.total) / 100;
    let message = this.dataset.minimumText.replace('[minimum]', format(minimum));
    if (this.dataset.context !== 'product' && sameCurrency) {
      message = remaining > 0
        ? this.dataset.remainingText.replace('[remaining]', format(remaining)).replace('[minimum]', format(minimum))
        : this.dataset.metText;
    }
    const output = this.querySelector('[data-pp-minimum]');
    output.textContent = message;
    output.hidden = false;
    const extra = this.querySelector('[data-pp-extra]');
    if (extra) extra.hidden = !sameCurrency || remaining <= 0;
  }
});

customElements.define('pp-sticky-cart', class extends HTMLElement {
  connectedCallback() {
    this.productInfo = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
    this.primary = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
    this.submit = this.querySelector('[data-pp-sticky-submit]');
    this.onStickyClick = () => this.primary?.click();
    this.submit.addEventListener('click', this.onStickyClick);
    this.price = this.querySelector('[data-pp-sticky-price]');
    if (!this.productInfo || !this.primary) return;
    this.viewport = matchMedia('(max-width: 749px)');
    this.refresh = () => this.update();
    this.visibility = new IntersectionObserver(() => this.update());
    this.visibility.observe(this.primary);
    this.contentObserver = new MutationObserver(this.refresh);
    this.contentObserver.observe(this.productInfo, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    this.bodyObserver = new MutationObserver(this.refresh);
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.viewport.addEventListener('change', this.refresh);
    this.update();
  }

  update() {
    const primary = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
    if (!primary) return;
    if (primary !== this.primary) {
      this.visibility.unobserve(this.primary);
      this.primary = primary;
      this.visibility.observe(primary);
    }
    const visible = this.viewport.matches && primary.getBoundingClientRect().bottom <= 0 && !document.body.classList.contains('overflow-hidden');
    this.hidden = !visible;
    if (document.body.classList.contains('pp-has-sticky') !== visible) document.body.classList.toggle('pp-has-sticky', visible);
    const label = primary.querySelector('span')?.textContent.trim();
    if (label && this.submit.textContent !== label) this.submit.textContent = label;
    this.submit.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
    const price = this.productInfo.querySelector('.price.price--on-sale .price-item--sale') ||
      this.productInfo.querySelector('.price__regular .price-item--regular');
    if (price && this.price.textContent !== price.textContent.trim()) this.price.textContent = price.textContent.trim();
    const sourceEstimate = this.productInfo.querySelector('.price > pp-converted-price');
    const stickyEstimate = this.querySelector('pp-converted-price');
    if (sourceEstimate && stickyEstimate) {
      ['data-ils-cents', 'data-max-ils-cents', 'data-from'].forEach(attribute => {
        const value = sourceEstimate.getAttribute(attribute);
        if (value === null) stickyEstimate.removeAttribute(attribute);
        else if (stickyEstimate.getAttribute(attribute) !== value) stickyEstimate.setAttribute(attribute, value);
      });
    }
  }

  disconnectedCallback() {
    this.submit?.removeEventListener('click', this.onStickyClick);
    this.visibility?.disconnect();
    this.contentObserver?.disconnect();
    this.bodyObserver?.disconnect();
    this.viewport?.removeEventListener('change', this.refresh);
    document.body.classList.remove('pp-has-sticky');
  }
});
